/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { socialProfileSuggestionWithContactResponseDtoSchema } from "./socialProfileSuggestionWithContactResponseDtoSchema";
import { z } from "zod/v4";

export const paginatedSocialProfileSuggestionsResponseDtoSchema = z.object({
    get "items"(){
                return z.array(socialProfileSuggestionWithContactResponseDtoSchema)
              },
"total": z.number(),
"pageNumber": z.number(),
"pageSize": z.number(),
"nextPage": z.nullable(z.string())
    })